



<div class="align-items-center container-fluid d-none d-lg-flex header-2-style p-0">



  <!-- all categories -->
  <div
    class="catogery-holder h-100"
    (mouseleave)="showCat(false)"
  >
    <div
    (click)="showCat(true);"

      class="align-items-center categories-btn-box-style col-2 d-flex h-100 justify-content-center px-3 w-100"
    >
      <button class="bg-transparent border-0 d-flex w-100 position-relative">
        <h1 class="fw-bold header-2-button-style mx-4 my-0 position-relative">
          {{  "all_categories" | translate: "header" }}
        </h1>

        <span class="after"></span>
      </button>
    </div>

    <div
      class="container table-holder w-100 position-absolute d-none"
      #cat
      style="
        cursor: pointer;
        background-color: #fcfbf4;
        border: #fff;
        z-index: 100;
      "
    >


      <div class="row catogery-section w-100">


        <div class="catogery row categories-btn-box-style w-50 me-2">
          <div class="catogery">
            <ul class="list-unstyled row mt-4">
              <li
                *ngFor="let cat of categories; let i = index"
                class="col-12 m-0 py-2"
                [routerLink]="['category', 'details', cat?.id]"
                (click)="showCat(false);"
              >
                <span
                (mouseenter)="showelement(true, i)"
                (mouseleave)="showelement(false, i)"
                (mouseover)="get_sub_cat(cat);"
                >
                  {{ cat?.name  }}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-8 w-50" *ngIf="active_cat?.sub_categories?.length">

          <div class="text">
            <p>{{ active_cat.name }}</p>
          </div>

          <div class="row">

            <div class="col-6 section">
              <div class="">
                <ul class="list-unstyled">
                  <li class="mt-0">{{  "most_popular" | translate: "header" }}</li>
                  <li *ngFor="let sub_cat of active_cat.sub_categories">
                    <a
                    (click)="swtichToProductList(sub_cat.id); showCat(false); onMouseLeave();"
                    class="text-decoration-none text-black"
                    >
                      {{ sub_cat?.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>


          </div>

        </div>

      </div>

    </div>
  </div>





  <!-- single category -->
  <div class="h-100" style="width: 80vw;">

    <ul
      class="align-items-center d-flex h-100 list-unstyled m-0 cat-box-style px-2"
    >
      <li
        class="align-items-center d-flex h-100 px-3 categorie-item-style"
        (mouseenter)="onMouseEnter(true)"
        (mouseleave)="onMouseLeave()"
        (mouseover)="get_sub_cat(cat);"
        *ngFor="let cat of categories?.slice(0, 7)"
      >
        <a
          class="fw-bold text-black text-decoration-none text-uppercase categories-item-font-size"
          routerLink="/products/products-list/"
          [queryParams]="{ category_id : cat.id }"
          (click)="onMouseEnter(false); onMouseLeave();"
        >
          {{ cat.name }}
        </a>

      </li>
    </ul>

  </div>

</div>








<!-- single category (data) -->
<div
  style="position: relative; display: none; z-index: 3;"
  class="header-category-menu"
  *ngIf="active_cat?.sub_categories?.length"
  #menu
>


  <div
  class="sc-bc85dbbd-3 jJltKU menu"
  (mouseenter)="onMouseEnterNoDelay(true)"
  (mouseleave)="onMouseLeave()"
  >

    <div class="jsx-undefined menuContent">

      <div class="jsx-undefined catsColumn">
        <p class="jsx-undefined heading">{{ active_cat.name }}</p>
        <ul class="jsx-undefined">
          <li class="jsx-undefined" *ngFor="let active_sub_cat of active_cat.sub_categories;">
            <a
            (click)="swtichToProductList(active_sub_cat.id); onMouseEnter(false); onMouseLeave();"
            >
              {{ active_sub_cat?.name }}
            </a>
          </li>
        </ul>
      </div>

      <div class="jsx-undefined bannersColumn">
        <div class="jsx-undefined banner" *ngIf="active_cat?.menu_photo">
          <a href="javascript: void(0);" >

            <img
            [defaultImage]="lazyLoadImage"
            [lazyLoad]="active_cat.menu_photo"
            alt="product"
            class="sc-afe2674f-1 cfKlFZ"
            />

          </a>
        </div>
      </div>

    </div>
  </div>


  <div class="sc-7c4627ed-9 fhlHSA"></div>


</div>
